

export const PROTECTED = "PROTECTED";

export const LOCAL_STORAGE_KEYS = {
  USER_META_DATA: "USER_META_DATA",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  REFRESH_TOKEN: "REFRESH_TOKEN",
  GOOGLE_AUTH_TOKEN: "GOOGLE_AUTH_TOKEN",
  GOOGLE_ACCESS_TOKEN: "GOOGLE_ACCESS_TOKEN",
  GOOGLE_REFRESH_TOKEN: "GOOGLE_REFRESH_TOKEN",
};

export const TIMEOUT_MILLISECONDS = 60 * 60 * 1000;
export const GENERAL_DEBOUNCE_TIME = 500;
export const SECONDS_TO_REFRESH_TOKEN = 30;

export const ROUTES = {
  dashboard: "/",
  login: "/login",
  generateArticle: "/generate-article/:session_id",
};


export const REMOVE_TOKENS = {
  LOCAL_STORAGE_KEYS: [
    LOCAL_STORAGE_KEYS.ACCESS_TOKEN,
    LOCAL_STORAGE_KEYS.REFRESH_TOKEN,
  ],
};
